export const defaultMessage: any = {
    Bannier: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
        Description: {
            AL:
                "Welkom op onze site! Ontdek, bestel en geniet van je maaltijden.",
            EN: "Welcome to our site! Discover, order, and enjoy your meals.",
            ES:
                "¡Bienvenido a nuestro sitio! Descubre, ordena y disfruta tus comidas.",
            FR:
                "Bienvenue sur notre site ! Découvrez, commandez et savourez vos repas.",
            IT:
                "Benvenuti nel nostro sito! Scopri, ordina e gusta i tuoi pasti.",
            PT:
                "Bem-vindo ao nosso site! Descubra, peça e saboreie suas refeições.",
        },
    },
    Section1: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
    },
    Section2: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
    },
    Section3: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
        Description: {
            AL:
                "Welkom op onze site! Ontdek, bestel en geniet van je maaltijden.",
            EN: "Welcome to our site! Discover, order, and enjoy your meals.",
            ES:
                "¡Bienvenido a nuestro sitio! Descubre, ordena y disfruta tus comidas.",
            FR:
                "Bienvenue sur notre site ! Découvrez, commandez et savourez vos repas.",
            IT:
                "Benvenuti nel nostro sito! Scopri, ordina e gusta i tuoi pasti.",
            PT:
                "Bem-vindo ao nosso site! Descubra, peça e saboreie suas refeições.",
        },
    },
    Section4: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
        Description: {
            AL:
                "Welkom op onze site! Ontdek, bestel en geniet van je maaltijden.",
            EN: "Welcome to our site! Discover, order, and enjoy your meals.",
            ES:
                "¡Bienvenido a nuestro sitio! Descubre, ordena y disfruta tus comidas.",
            FR:
                "Bienvenue sur notre site ! Découvrez, commandez et savourez vos repas.",
            IT:
                "Benvenuti nel nostro sito! Scopri, ordina e gusta i tuoi pasti.",
            PT:
                "Bem-vindo ao nosso site! Descubra, peça e saboreie suas refeições.",
        },
    },
    Head: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
    },
    Loyalty: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
        Description: {
            AL:
                "Welkom op onze site! Ontdek, bestel en geniet van je maaltijden.",
            EN: "Welcome to our site! Discover, order, and enjoy your meals.",
            ES:
                "¡Bienvenido a nuestro sitio! Descubre, ordena y disfruta tus comidas.",
            FR:
                "Bienvenue sur notre site ! Découvrez, commandez et savourez vos repas.",
            IT:
                "Benvenuti nel nostro sito! Scopri, ordina e gusta i tuoi pasti.",
            PT:
                "Bem-vindo ao nosso site! Descubra, peça e saboreie suas refeições.",
        },
    },
    Offres: {
        Title: {
            AL: "Volg je bestelling door je",
            EN: "Track your order by entering your",
            ES: "Para rastrear tu pedido, ingresa tu",
            FR:
                "Pour suivre l'état de votre commande, veuillez renseigner votre",
            IT: "Per tracciare il tuo ordine, inserisci il tuo",
            PT: "Para rastrear seu pedido, insira seu",
        },
    },
};
export const activeLanguages = [
    {
        active: true,
        flag: "https://flagpedia.net/data/flags/h80/fr.webp",
        id: "5c2ce585-68ca-49c8-9fda-d64f1e9fba40",
        isDefault: true,
        language: "French",
        name: "FR",
        title: "Français",
    },
    {
        active: true,
        flag: "https://flagpedia.net/data/flags/h80/gb.webp",
        id: "3de90539-c727-40aa-a9a2-af84be160223",
        isDefault: true,
        language: "English",
        name: "EN",
        title: "Anglais",
    },
    {
        active: true,
        flag: "https://flagpedia.net/data/flags/h80/es.webp",
        id: "0d436099-4cf6-4f26-9d2f-372d9a0207c5",
        isDefault: true,
        language: "Spanish",
        name: "ES",
        title: "Espagnol",
    },
    {
        active: true,
        flag: "https://flagpedia.net/data/flags/h80/de.webp",
        id: "bb13c224-e4ae-493b-b8d5-1ab880e5ff2e",
        isDefault: true,
        language: "German",
        name: "AL",
        title: "Allemand",
    },
    {
        active: true,
        flag: "https://flagpedia.net/data/flags/h80/it.webp",
        id: "dfa2b4f6-9bf3-4eb4-a171-0707deff50f3",
        isDefault: true,
        language: "Italian",
        name: "IT",
        title: "Italien",
    },
];
export const validUploadedTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "video/mp4",
    "video/webm",
];
export const baseURL = process.env.REACT_APP_C_AND_C?.replace(
    /\/api_C&C\/v1\/?$/,
    ""
);
